<template>
  <v-alert v-if="filterCurrentProduct.length > 0" :value="hasProducts" color="error" transition="scroll-y-transition" class="white--text mt-2 mb-n2">
    <template #prepend>
      <v-icon color="white" class="mr-6">{{ mdiAlert }}</v-icon>
    </template>
    <v-row no-gutters align="center">
      <v-col>
        <span>Possibly related accounts found, this might be an existing customer</span>
      </v-col>

      <v-col class="shrink">
        <v-btn fab small text target="_blank" :to="`/accounts/${this.filterCurrentProduct[0].account_id}`">
          <v-icon color="white" @click="'/'">{{ mdiOpenInNew }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiOpenInNew, mdiAlert } from '@mdi/js';

export default {
  data() {
    return {
      show: true,
      mdiOpenInNew,
      mdiAlert,
    }
  },

  computed: {
    ...mapGetters('productGeneral', ['getProducts', 'getSearchProductsLoading']),
    ...mapGetters('leads', ['getCurrentLead']),

    filterCurrentProduct() {
      if(!this.getProducts) return [];
      return this.getProducts.filter(product => {
        if(product.account_id && this.getCurrentLead.account_id) {
          return product.account_id.toString() !== this.getCurrentLead.account_id.toString()
        }
        return product;
      });
    },

    hasProducts() {
      if(!this.getProducts) return false;
      return true;
    }
  },
}
</script>

<style lang="scss" scoped></style>
